export const PTZ_PRIVILEGE_INITIAL = "PTZ_PRIVILEGE_INITIAL";
export const PTZ_PRIVILEGE_UPDATE = "PTZ_PRIVILEGE_UPDATE";
export const PTZ_PRIVILEGE_STREAM_STARTED = "PTZ_PRIVILEGE_STREAM_STARTED";
export const PTZ_PRIVILEGE_STREAM_STOPPED = "PTZ_PRIVILEGE_STREAM_STOPPED";
export const PTZ_PRIVILEGE_STREAM_CONTEXT_ADDED = "PTZ_PRIVILEGE_STREAM_CONTEXT_ADDED";
export const PTZ_PRIVILEGE_STREAM_CONTEXT_REMOVED = "PTZ_PRIVILEGE_STREAM_CONTEXT_REMOVED";
